import { Box, Card, CardContent, Chip, Stack, Typography } from '@mui/material'
import { useState } from 'react';
import { IconName } from '../../../../../shared/interfaces/icon-picker.model';
import { IconPicker } from '../../../display-elements-components/icon-picker';
import { monogramInitials, monogramTone } from '../../../../../shared/utils/monogram-utils';

export const EmissionsInputCard: React.FC<{
  icon?: IconName,
  title: string,
  description?: string,
  selected?: boolean,
  backgroundColor: string;
  tenantPage?: boolean,
  padding?: number;
  showChip?: boolean;
  chipLabel?: string;
  imageFilePath?: string;
  // Catalogue cards without an uploaded image show a deterministic initials tile
  // instead of the shared generic icon, so every record reads as its own thing.
  monogramFallback?: boolean;
}> = ({
  icon,
  title,
  description,
  selected = false,
  backgroundColor,
  padding = 4,
  tenantPage = false,
  showChip = false,
  chipLabel = '',
  imageFilePath,
  monogramFallback = false }) => {

    const [hover, setHover] = useState(false);
    const [imageError, setImageError] = useState(false);


    return (
      <Card sx={{
        height: '100%',
        boxShadow: 'none',
        borderWidth: '2px',
        borderStyle: 'solid', borderColor: selected ? 'primary.main' : 'lightGrey.main', borderRadius: '10px', backgroundColor: selected ? backgroundColor : hover ? 'lightGrey.light' : 'common.white'
      }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: padding, position: 'relative' }}>
          {imageFilePath && !imageError &&
            <Box sx={{ pb: 2, pt: 2, width: '50px', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img
                src={imageFilePath}
                alt={title}
                style={{
                  width: `50px`,
                  height: `50px`,
                  objectFit: 'cover',
                  borderRadius: '8px'
                }}
                onError={() => setImageError(true)}
              />
            </Box>
          }
          {monogramFallback && (!imageFilePath || imageError) &&
            <Box sx={{ mb: 2, mt: 2, width: '56px', height: '56px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '10px', backgroundColor: monogramTone(title).background }}>
              <Typography sx={{ color: monogramTone(title).color, fontWeight: 600, fontSize: '1.15rem', letterSpacing: '0.02em' }}>
                {monogramInitials(title)}
              </Typography>
            </Box>}
          {icon && !monogramFallback && (!imageFilePath || imageError) &&
            <Box sx={{ pb: 2, pt: 2, width: '50px', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <IconPicker icon={icon} color={selected ? 'primary.main' : 'text.secondary'} scale={2.1} />
            </Box>}
          <Stack>
            <Typography variant='subtitle1' sx={{ color: selected ? 'primary.main' : 'text.primary', textAlign: 'center', pb: 1 }}>
              {title}
            </Typography>
            {description && <Typography variant='body2' sx={{ color: 'text.secondary', textAlign: 'center', pb: 2 }}>
              {description}
            </Typography>}
          </Stack>
          {showChip && <Chip color='primary' variant='outlined' label={chipLabel} />}
          {/* {!tenantPage && selected && <CheckCircle sx={{ pb: 2 }} />}
          {!tenantPage && !selected && <CheckCircleOutline sx={{ pb: 2 }} />}
          {tenantPage && hover && <CheckCircle sx={{ pb: 2 }} />}
          {tenantPage && !hover && <CheckCircleOutline sx={{ pb: 2 }} />} */}
        </CardContent>
      </Card >
    )
  }